import { DialogId } from '@feedyou/schema'
import { RootState } from '../../../reducers'
import { deadEndsSelector } from './deadEndsSelector'

export const isPossibleDeadEndSelector = (state: RootState, dialogId: DialogId) => {
  return deadEndsSelector(state).possible.has(dialogId)
}
